export default __webpack_public_path__ + "static/simple-histogram-5ad4f6d3c321e2934e302c7794c766f7.png";